<script setup lang="ts">
const slots = useSlots()

const props = defineProps({
  color: {
    type: String as PropType<'grey' | 'white' | 'darkwhite' | 'darkgrey' | 'red' | 'green' | 'darkgreen' | 'orange' | 'purple' | 'blue' | 'primary'>,
    default: 'grey',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: false,
  },
  titleIcon: {
    type: String,
    required: false,
  },
  titleSize: {
    type: String as PropType<'lg' | '2xl' | 'base'>,
    default: 'lg',
  },
})

const backgroundColorClass = computed(() => {
  if (props.color === 'white') {
    return 'bg-surface-0'
  }

  if (props.color === 'darkwhite') {
    return 'bg-surface-50'
  }

  if (props.color === 'darkgrey') {
    return 'bg-surface-200'
  }

  if (props.color === 'red') {
    return 'bg-red-100'
  }

  if (props.color === 'green') {
    return 'bg-green-100'
  }

  if (props.color === 'darkgreen') {
    return 'bg-green-200'
  }

  if (props.color === 'orange') {
    return 'bg-orange-100'
  }

  if (props.color === 'purple') {
    return 'bg-purple-100'
  }

  if (props.color === 'blue') {
    return 'bg-blue-100'
  }

  if (props.color === 'primary') {
    return 'bg-primary-500'
  }

  return 'bg-surface-100'
})

const borderColorClass = computed(() => {
  if (props.color === 'white') {
    return 'border-surface-200'
  }

  if (props.color === 'darkwhite') {
    return 'border-surface-700'
  }

  if (props.color === 'darkgrey') {
    return 'border-surface-300'
  }

  if (props.color === 'red') {
    return 'border-red-500'
  }

  if (props.color === 'green') {
    return 'border-green-500'
  }

  if (props.color === 'darkgreen') {
    return 'border-green-700'
  }

  if (props.color === 'orange') {
    return 'border-orange-500'
  }

  if (props.color === 'purple') {
    return 'border-purple-500'
  }

  if (props.color === 'blue') {
    return 'border-blue-500'
  }

  if (props.color === 'primary') {
    return 'border-primary-500'
  }

  return 'border-surface-200'
})

const textColorClass = computed(() => {
  if (props.color === 'white') {
    return 'text-surface-900'
  }

  if (props.color === 'darkwhite') {
    return 'text-surface-700'
  }

  if (props.color === 'darkgrey') {
    return 'text-surface-700'
  }

  if (props.color === 'red') {
    return 'text-red-700'
  }

  if (props.color === 'green') {
    return 'text-green-700'
  }

  if (props.color === 'darkgreen') {
    return 'text-green-900'
  }

  if (props.color === 'orange') {
    return 'text-orange-700'
  }

  if (props.color === 'purple') {
    return 'text-purple-700'
  }

  if (props.color === 'blue') {
    return 'text-blue-700'
  }

  if (props.color === 'primary') {
    return 'text-primary-contrast'
  }

  return 'text-surface-700'
})

const titleTextSize = computed(() => {
  if (props.titleSize === '2xl') {
    return 'text-2xl'
  }

  if (props.titleSize === 'base') {
    return 'text-base'
  }

  return 'text-lg'
})

const titleBottomBorder = computed(() => {
  if (!slots.default) {
    return ''
  }

  if (props.titleSize === '2xl') {
    return 'mb-4'
  }

  if (props.titleSize === 'base') {
    return 'mb-2'
  }

  return 'mb-2'
})

const iconFontSize = computed(() => {
  if (props.titleSize === '2xl') {
    return 'font-size: 1.333rem'
  }

  if (props.titleSize === 'base') {
    return 'font-size: 0.888rem'
  }

  return 'font-size: 1rem'
})

const iconRightBorder = computed(() => {
  if (props.titleSize === '2xl') {
    return 'mr-2'
  }

  if (props.titleSize === 'base') {
    return 'mr-1.5'
  }

  return 'mr-1.5'
})
</script>

<template>
  <BlockUI
    :blocked="props.disabled"
    :class="['p-4', 'rounded-xl', 'border-2', textColorClass, backgroundColorClass, borderColorClass]"
  >
    <div
      v-if="props.title"
      :class="[titleTextSize, titleBottomBorder, 'font-medium']"
    >
      <i
        v-if="props.titleIcon"
        :style="[iconFontSize]"
        :class="['pi', props.titleIcon, iconRightBorder]"
      />{{ props.title }}
    </div>
    <slot />
  </BlockUI>
</template>
